import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { User, LoginRequest } from '@/types/user'
import { login as loginApi } from '@/api/auth'

export const useUserStore = defineStore('user', () => {
  const userStr = localStorage.getItem('user')
  const user = ref<User | null>(userStr ? JSON.parse(userStr) : null)
  const token = ref<string | null>(localStorage.getItem('token'))

  const isLoggedIn = computed(() => !!token.value && !!user.value)

  const login = async (username: string, password: string) => {
    try {
      const loginData: LoginRequest = { username, password }
      const response = await loginApi(loginData)
      user.value = response.user
      token.value = response.token
      localStorage.setItem('token', response.token)
      localStorage.setItem('user', JSON.stringify(response.user))
      return response
    } catch (error) {
      throw error;
    }
  }

  const logout = () => {
    user.value = null
    token.value = null
    localStorage.removeItem('token')
    localStorage.removeItem('user')
  }

  const setUser = (userData: User) => {
    user.value = userData
  }

  return {
    user,
    token,
    isLoggedIn,
    login,
    logout,
    setUser
  }
}) 